import type React from "react";
import {
	TextField,
} from "@mui/material";
import type { TextFieldProps } from "@mui/material/TextField";


interface SimpleTextAreaControlProps {
	value: string;
	onChange?: (value: string) => void;
	disabled?: boolean;
	placeholder?: string;
	label?: string;
	rows?: number;
	maxRows?: number;
	minRows?: number;
	variant?: TextFieldProps["variant"];
	fullWidth?: boolean;
	error?: boolean;
	helperText?: string;
	showColor?: boolean;
	styleText?: React.CSSProperties;
	className?: string;
	autoFocus?: boolean;
	onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
	onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
	onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export const SimpleTextAreaControl: React.FC<SimpleTextAreaControlProps> = ({
	value,
	onChange,
	disabled = false,
	placeholder,
	label,
	maxRows,
	minRows,
	variant = "filled",
	fullWidth = true,
	error = false,
	helperText,
	showColor = true,
	styleText,
	className,
	autoFocus = false,
	onKeyDown,
	onBlur,
	onFocus,
}) => {

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (onChange) onChange(event.target.value);
	};

	const combinedStyles = {
		...(disabled && !showColor ? { color: "#666" } : {}),
		...styleText,
	};

	return (
		<TextField
			value={value || ""}
			onChange={handleChange}
			disabled={disabled}
			placeholder={placeholder}
			label={label}
			multiline
			maxRows={maxRows}
			minRows={minRows}
			variant={variant as TextFieldProps["variant"]}
			fullWidth={fullWidth}
			error={error}
			helperText={helperText}
			autoFocus={autoFocus}
			onKeyDown={onKeyDown}
			onBlur={onBlur}
			onFocus={onFocus}
			style={{
				width: "100%",
				...styleText,
			}}
			className={className || ""}
			slotProps={{
				input: {
					style: combinedStyles,
					disableUnderline: true,
				},
				htmlInput: {
					style: {
						overflow: "auto",
						resize: "none",
						...styleText,
					},
				},
			}} />
	);
};
